module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/experiences/wedding/03_decorations.png";